storeKeyNameFromField